import initVueApp from "@/core.js";
const component = require(`./../views/SeamLanding.vue`).default;
initVueApp(component);
